/**
 * These shared config items eliminate the need for non-performant calls to the theme.
 * This should help reduce the time it takes to calculate Emotion styles.
 * See this blog post for more: https://itnext.io/how-to-increase-css-in-js-performance-by-175x-f30ddeac6bce
 */

export const config = {
  sizes: {
    down: {
      xs: 599,
      sm: 1023,
      md: 1439,
    },
    up: {
      xs: 0,
      sm: 600,
      md: 1024,
    },
  },
  colors: {
    white: 'var(--cds-color-white-0)',
    black: 'var(--cds-color-neutral-primary)',
    grey100: 'var(--cds-color-grey-25)',
    grey300: 'var(--cds-color-grey-50)',
    grey400: 'var(--cds-color-grey-200)',
    grey500: 'var(--cds-color-grey-400)',
    grey700: 'var(--cds-color-grey-600)',
    blue600: 'var(--cds-color-blue-700)',
    blue900: 'var(--cds-color-blue-950)',
    purple800: 'var(--cds-color-purple-800)',
    yellow500: 'var(--cds-color-yellow-200)',
  },
  typography: {
    fontFamily: '"Source Sans Pro",Arial,sans-serif',
    body2: {
      fontSize: '0.875rem', // 14px
      lineHeight: '1.25rem', // 20px
      fontFamily: '"Source Sans Pro",Arial,sans-serif',
      fontWeight: 'normal',
      fontStyle: 'normal',
    },
  },
} as const;
